export const truncateText = (text, limit) => {
    // Check if text is defined and not null
    if (!text) {
      return "";
    }
  
    const words = text.split(" ");
  
    if (words.length > limit) {
      return words.slice(0, limit).join(" ") + "...";
    }
  
    return text;
  };
  